const settings = {
  baseApiUrl: "https://api.vaix.ai",
  operator: "casino_demo",
  vaixClientId: "casino_demo",
  widgetSettingsType: "widget_settings",
  components: {
    sliderItem: {
      magnifyOnHover: true,
      showPlayBtnOnHover: true,
      tags: [],
    },
  },
  widgetConfig: {
    pages: [
      {
        pageId: "homepage",
        pageName: "Kambi Demo Homepage",
        pageUrl: "/",
        elements: [
          // {
          //   id: "cross_sell_swimlane",
          //   name: "Personalized Games",
          //   type: "carousel",
          //   properties: {
          //     title: "Recommended For You",
          //     carouselKey: "recommended",
          //     fetchUrl: "/games/recommended",
          //     fetchParams: {
          //       count: 24,
          //     },
          //     maxItemsPerRow: 8,
          //     rows: 1,
          //   },
          // },
          {
            id: "cross_sell_swimlane_embeddings",
            name: "Personalized Games",
            type: "carousel",
            properties: {
              title: "Recommended For You",
              carouselKey: "recommendedEmbeddings",
              fetchUrl: "/games/recommended",
              fetchParams: {
                count: 24,
              },
              maxItemsPerRow: 8,
              rows: 1,
            },
          },
        ],
      },
    ],
  },
};

export default settings;
